exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.failover .md-chip[data-v-50d7dcf6]{max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:middle;color:red\n}\n.validation-error-message[data-v-50d7dcf6]{width:100%;margin:10px 0;padding:15px;background-color:#ff5722;color:#ebfaff;font-size:1.1em\n}\n.validation-error-message .md-icon[data-v-50d7dcf6]{margin-top:-2px;margin-right:5px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-50d7dcf6","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/Vast.vue
// module id = 145
// module chunks = 0